// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-company-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .sa-company-form-container {
    padding: 1rem;
  }
}
.sa-company-form-container .sa-company-form-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: company-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .sa-company-form-container .sa-company-form-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.sa-company-form-container .sa-company-form-header {
  text-align: center;
  margin-bottom: 0.5rem;
}
.sa-company-form-container .sa-company-form-header .sa-company-form-title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 0.5rem 0;
}
@media (max-width: 768px) {
  .sa-company-form-container .sa-company-form-header .sa-company-form-title {
    font-size: 1.25rem;
  }
}
.sa-company-form-container .sa-company-form-header .sa-company-form-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}
.sa-company-form-container .sa-company-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.sa-company-form-container .form-header {
  display: none;
}
.sa-company-form-container .company-form,
.sa-company-form-container .form-content {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  animation: none;
  width: 100%;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form,
  .sa-company-form-container .form-content {
    padding: 0;
    width: 100%;
  }
}
.sa-company-form-container .company-form .form-section,
.sa-company-form-container .form-content .form-section {
  padding-bottom: 1.5rem;
}
.sa-company-form-container .company-form .form-section:last-of-type,
.sa-company-form-container .form-content .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.sa-company-form-container .company-form .form-section h3,
.sa-company-form-container .form-content .form-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.sa-company-form-container .company-form .form-grid,
.sa-company-form-container .form-content .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .form-grid,
  .sa-company-form-container .form-content .form-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group {
  display: flex;
  flex-direction: column;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.full-width,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.full-width {
  grid-column: 1/-1;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group label,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group label .required,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group label .required {
  color: #ef4444;
  margin-left: 0.25rem;
  font-size: 0.875rem;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.5rem;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input:focus,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select:focus,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea:focus,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input:focus,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select:focus,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input:hover:not(:focus),
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select:hover:not(:focus),
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea:hover:not(:focus),
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input:hover:not(:focus),
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select:hover:not(:focus),
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input::placeholder,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select::placeholder,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea::placeholder,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input::placeholder,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select::placeholder,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea::placeholder {
  color: #9ca3af;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group input:disabled,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select:disabled,
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group input:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
  cursor: pointer;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select:disabled {
  cursor: not-allowed;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group select option,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group select option {
  padding: 0.5rem;
  background: #ffffff;
  color: #374151;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea {
  resize: vertical;
  min-height: 4rem;
  padding: 0.5rem;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group .error,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group .error {
  color: #ef4444;
  font-size: 0.75rem;
  margin-top: 0.25rem;
  font-weight: 500;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle {
  flex-direction: column;
  gap: 0.75rem;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle label,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle label {
  margin-bottom: 0;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle label .required,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle label .required {
  display: none;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple {
  position: relative;
  width: 48px;
  height: 24px;
  background-color: #d1d5db;
  border-radius: 12px;
  transition: background-color 0.2s ease;
  cursor: pointer;
  border: none;
  padding: 0;
  min-height: auto;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple::before,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple.active,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple.active {
  background-color: var(--primary-color);
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple.active::before,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple.active::before {
  transform: translateX(24px);
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple:focus,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple:disabled,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .toggle-switch-simple:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.sa-company-form-container .company-form .form-grid .sa-comp-form-group.company-status-toggle .status-text,
.sa-company-form-container .form-content .form-grid .sa-comp-form-group.company-status-toggle .status-text {
  font-size: 0.75rem;
  color: #6b7280;
  margin-left: 0.5rem;
}
.sa-company-form-container .company-form .visibility-section .module-rights-header,
.sa-company-form-container .form-content .visibility-section .module-rights-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .visibility-section .module-rights-header,
  .sa-company-form-container .form-content .visibility-section .module-rights-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
}
.sa-company-form-container .company-form .visibility-section h3,
.sa-company-form-container .form-content .visibility-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}
.sa-company-form-container .company-form .visibility-section .override-toggle-container,
.sa-company-form-container .form-content .visibility-section .override-toggle-container {
  display: flex;
  align-items: center;
}
.sa-company-form-container .company-form .visibility-section .override-toggle-container .override-toggle-label,
.sa-company-form-container .form-content .visibility-section .override-toggle-container .override-toggle-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  margin: 0;
}
.sa-company-form-container .company-form .visibility-section .override-toggle-container .override-toggle-label .override-label-text,
.sa-company-form-container .form-content .visibility-section .override-toggle-container .override-toggle-label .override-label-text {
  -webkit-user-select: none;
          user-select: none;
}
.sa-company-form-container .company-form .visibility-section .custom-rights-info,
.sa-company-form-container .company-form .visibility-section .plan-rights-info,
.sa-company-form-container .form-content .visibility-section .custom-rights-info,
.sa-company-form-container .form-content .visibility-section .plan-rights-info {
  background-color: #f3f4f6;
  border-left: 3px solid var(--primary-color, #3b82f6);
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border-radius: 0.375rem;
}
.sa-company-form-container .company-form .visibility-section .custom-rights-info p,
.sa-company-form-container .company-form .visibility-section .plan-rights-info p,
.sa-company-form-container .form-content .visibility-section .custom-rights-info p,
.sa-company-form-container .form-content .visibility-section .plan-rights-info p {
  margin: 0;
  font-size: 0.875rem;
  color: #4b5563;
}
.sa-company-form-container .company-form .visibility-section .loading-rights,
.sa-company-form-container .form-content .visibility-section .loading-rights {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
  font-size: 0.875rem;
}
.sa-company-form-container .company-form .visibility-section .visibility-toggles,
.sa-company-form-container .form-content .visibility-section .visibility-toggles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .visibility-section .visibility-toggles,
  .sa-company-form-container .form-content .visibility-section .visibility-toggles {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.75rem;
  }
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions,
.sa-company-form-container .form-content .visibility-section .custom-rights-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights,
.sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights {
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color, #3b82f6);
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights:hover:not(:disabled),
.sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights:hover:not(:disabled) {
  background-color: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights:active:not(:disabled),
.sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights:active:not(:disabled) {
  transform: translateY(0);
}
.sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights:disabled,
.sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .visibility-section .custom-rights-actions .btn-save-custom-rights,
  .sa-company-form-container .form-content .visibility-section .custom-rights-actions .btn-save-custom-rights {
    width: 100%;
  }
}
.sa-company-form-container .company-form .visibility-section .toggle-label,
.sa-company-form-container .form-content .visibility-section .toggle-label {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  text-transform: capitalize;
  margin-bottom: 0;
}
.sa-company-form-container .company-form .visibility-section .toggle-switch,
.sa-company-form-container .form-content .visibility-section .toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  cursor: pointer;
}
.sa-company-form-container .company-form .visibility-section .toggle-switch input,
.sa-company-form-container .form-content .visibility-section .toggle-switch input {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}
.sa-company-form-container .company-form .visibility-section .toggle-switch input:checked + .slider,
.sa-company-form-container .form-content .visibility-section .toggle-switch input:checked + .slider {
  background-color: var(--primary-color, #3b82f6);
}
.sa-company-form-container .company-form .visibility-section .toggle-switch input:checked + .slider::before,
.sa-company-form-container .form-content .visibility-section .toggle-switch input:checked + .slider::before {
  transform: translateX(26px);
}
.sa-company-form-container .company-form .visibility-section .toggle-switch input:focus + .slider,
.sa-company-form-container .form-content .visibility-section .toggle-switch input:focus + .slider {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.sa-company-form-container .company-form .visibility-section .toggle-switch .slider,
.sa-company-form-container .form-content .visibility-section .toggle-switch .slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  border-radius: 24px;
  transition: all 0.3s ease;
}
.sa-company-form-container .company-form .visibility-section .toggle-switch .slider::before,
.sa-company-form-container .form-content .visibility-section .toggle-switch .slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.sa-company-form-container .company-form .visibility-section .toggle-switch:hover .slider,
.sa-company-form-container .form-content .visibility-section .toggle-switch:hover .slider {
  background-color: #9ca3af;
}
input:checked + .sa-company-form-container .company-form .visibility-section .toggle-switch:hover .slider,
input:checked + .sa-company-form-container .form-content .visibility-section .toggle-switch:hover .slider {
  background-color: #2563eb;
}
.sa-company-form-container .company-form .form-actions,
.sa-company-form-container .form-content .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .form-actions,
  .sa-company-form-container .form-content .form-actions {
    flex-direction: column;
  }
}
.sa-company-form-container .company-form .form-actions .btn-submit,
.sa-company-form-container .form-content .form-actions .btn-submit {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .sa-company-form-container .company-form .form-actions .btn-submit,
  .sa-company-form-container .form-content .form-actions .btn-submit {
    width: 100%;
  }
}
.sa-company-form-container .company-form .form-actions .btn-submit:disabled,
.sa-company-form-container .form-content .form-actions .btn-submit:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.sa-company-form-container .company-form .form-actions .btn-cancel,
.sa-company-form-container .form-content .form-actions .btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.sa-company-form-container .company-form .form-actions .btn-cancel:hover,
.sa-company-form-container .form-content .form-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.sa-company-form-container .company-form .form-actions .btn-submit,
.sa-company-form-container .form-content .form-actions .btn-submit {
  background-color: var(--primary-color);
  color: white;
}
.sa-company-form-container .company-form .form-actions .btn-submit:hover,
.sa-company-form-container .form-content .form-actions .btn-submit:hover {
  background-color: #005a9a;
}
.sa-company-form-container .company-form .form-actions .btn-submit:focus,
.sa-company-form-container .form-content .form-actions .btn-submit:focus {
  outline: none;
}
.sa-company-form-container .company-form .form-actions .btn-submit.disabled, .sa-company-form-container .company-form .form-actions .btn-submit:disabled,
.sa-company-form-container .form-content .form-actions .btn-submit.disabled,
.sa-company-form-container .form-content .form-actions .btn-submit:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.sa-company-form-container .loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 70%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .sa-company-form-container .loading {
    width: 100%;
  }
}
.sa-company-form-container .loading-rights {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: #6b7280;
  font-size: 0.875rem;
  font-style: italic;
}

@keyframes company-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .sa-company-form-container .sa-company-form-wrapper {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .sa-company-form-container {
    padding: 0.5rem;
  }
  .sa-company-form-container .sa-company-form-wrapper {
    padding: 0.75rem;
  }
  .sa-company-form-container .sa-company-form-header .sa-company-form-title {
    font-size: 1.125rem;
  }
  .sa-company-form-container .sa-company-form-header .sa-company-form-subtitle {
    font-size: 0.8125rem;
  }
  .sa-company-form-container .company-form .form-grid,
  .sa-company-form-container .form-content .form-grid {
    gap: 0.5rem;
  }
  .sa-company-form-container .company-form .form-grid .sa-comp-form-group label,
  .sa-company-form-container .form-content .form-grid .sa-comp-form-group label {
    font-size: 0.8125rem;
  }
  .sa-company-form-container .company-form .form-grid .sa-comp-form-group input,
  .sa-company-form-container .company-form .form-grid .sa-comp-form-group select,
  .sa-company-form-container .company-form .form-grid .sa-comp-form-group textarea,
  .sa-company-form-container .form-content .form-grid .sa-comp-form-group input,
  .sa-company-form-container .form-content .form-grid .sa-comp-form-group select,
  .sa-company-form-container .form-content .form-grid .sa-comp-form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .sa-company-form-container .company-form .form-actions .btn-cancel,
  .sa-company-form-container .company-form .form-actions .btn-submit,
  .sa-company-form-container .form-content .form-actions .btn-cancel,
  .sa-company-form-container .form-content .form-actions .btn-submit {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
  .sa-company-form-container .company-form .visibility-section .visibility-toggles,
  .sa-company-form-container .form-content .visibility-section .visibility-toggles {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 0.5rem;
  }
}
@media print {
  .sa-company-form-container {
    background: white;
    padding: 0;
  }
  .sa-company-form-container .sa-company-form-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .sa-company-form-container .form-actions {
    display: none;
  }
}
.sa-company-form-container input:focus-visible,
.sa-company-form-container select:focus-visible,
.sa-company-form-container textarea:focus-visible,
.sa-company-form-container button:focus-visible {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}
.sa-company-form-container .toggle-switch input:focus-visible + .slider {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}
.sa-company-form-container .readonly-field {
  background-color: #f5f5f5 !important;
  cursor: not-allowed !important;
  opacity: 0.7;
  color: #6b7280;
}
.sa-company-form-container .readonly-field:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #d1d5db !important;
}
.sa-company-form-container .readonly-field:hover {
  border-color: #d1d5db !important;
}`, "",{"version":3,"sources":["webpack://./src/forms/SACompanyForm/SACompanyForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EATF;IAUI,aAAA;EACF;AACF;AAEE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,6CAAA;EACA,UAAA;AAAJ;AAEI;EATF;IAUI,aAAA;IACA,WAAA;EACJ;AACF;AAGE;EACE,kBAAA;EACA,qBAAA;AADJ;AAGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AADN;AAGM;EANF;IAOI,kBAAA;EAAN;AACF;AAGI;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AADN;AAME;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAJJ;AAQE;EACE,aAAA;AANJ;AAUE;;EAEE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AARJ;AAUI;EATF;;IAUI,UAAA;IACA,WAAA;EANJ;AACF;AASI;;EAEE,sBAAA;AAPN;AAUM;;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAPR;AAUM;;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAPR;AAYI;;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AATN;AAYM;EANF;;IAOI,0BAAA;IACA,WAAA;EARN;AACF;AAUM;;EACE,aAAA;EACA,sBAAA;AAPR;AASQ;;EACE,iBAAA;AANV;AASQ;;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AANV;AAQU;;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;AALZ;AAUQ;;;;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AALV;AAOU;;;;;;EACE,aAAA;EACA,2CAAA;EACA,6CAAA;AAAZ;AAGU;;;;;;EACE,qBAAA;AAIZ;AADU;;;;;;EACE,cAAA;AAQZ;AALU;;;;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAYZ;AARQ;;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AAWV;AATU;;EACE,mBAAA;AAYZ;AATU;;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AAYZ;AARQ;;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AAWV;AARQ;;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAWV;AAPM;;EACE,sBAAA;EACA,YAAA;AAUR;AAPQ;;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAUV;AARU;;EACE,aAAA;AAWZ;AAPQ;;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,sCAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AAUV;AARU;;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,wCAAA;AAWZ;AARU;;EACE,sCAAA;AAWZ;AATY;;EACE,2BAAA;AAYd;AARU;;EACE,0BAAA;EACA,mBAAA;AAWZ;AARU;;EACE,YAAA;EACA,mBAAA;AAWZ;AAPQ;;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AAUV;AAHM;;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;AAMR;AAJQ;EARF;;IASI,sBAAA;IACA,uBAAA;IACA,SAAA;EAQR;AACF;AALM;;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAQR;AALM;;EACE,aAAA;EACA,mBAAA;AAQR;AANQ;;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;AASV;AAPU;;EACE,yBAAA;UAAA,iBAAA;AAUZ;AALM;;;;EAEE,yBAAA;EACA,oDAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;AASR;AAPQ;;;;EACE,SAAA;EACA,mBAAA;EACA,cAAA;AAYV;AARM;;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAWR;AARM;;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAWR;AATQ;EANF;;IAOI,4DAAA;IACA,YAAA;EAaR;AACF;AAVM;;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AAaR;AAXQ;;EACE,uBAAA;EACA,+CAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAcV;AAZU;;EACE,yBAAA;EACA,2BAAA;EACA,wCAAA;AAeZ;AAZU;;EACE,wBAAA;AAeZ;AAZU;;EACE,YAAA;EACA,mBAAA;AAeZ;AAZU;EA1BF;;IA2BI,WAAA;EAgBV;AACF;AAZM;;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;AAeR;AAZM;;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAeR;AAbQ;;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAgBV;AAdU;;EACE,+CAAA;AAiBZ;AAfY;;EACE,2BAAA;AAkBd;AAdU;;EACE,6CAAA;AAiBZ;AAbQ;;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAgBV;AAdU;;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AAiBZ;AAbQ;;EACE,yBAAA;AAgBV;AAdU;;EACE,yBAAA;AAiBZ;AAVI;;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAaN;AAXM;EAPF;;IAQI,sBAAA;EAeN;AACF;AAZM;;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAeR;AAbQ;EAdF;;IAeI,WAAA;EAiBR;AACF;AAfQ;;EACE,mBAAA;EACA,YAAA;AAkBV;AAdM;;EAiBE,iBAAA;EACF,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AACN;AACM;;EACE,yBAAA;AAER;AAEM;;EACE,sCAAA;EACA,YAAA;AACR;AAIQ;;EACE,yBAAA;AADV;AAIQ;;EACE,aAAA;AADV;AAIQ;;;EAEE,yBAAA;EACA,cAAA;AADV;AAsBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;AApBJ;AAsBI;EAXF;IAYI,WAAA;EAnBJ;AACF;AAsBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AApBJ;;AAyBA;EACE;IACE,UAAA;IACA,2BAAA;EAtBF;EAyBA;IACE,UAAA;IACA,wBAAA;EAvBF;AACF;AA0BA;EACE;IACE,uBAAA;EAxBF;EA2BA;IACE,yBAAA;EAzBF;AACF;AA6BA;EAEI;IACE,WAAA;EA5BJ;AACF;AAgCA;EACE;IACE,eAAA;EA9BF;EAgCE;IACE,gBAAA;EA9BJ;EAkCI;IACE,mBAAA;EAhCN;EAmCI;IACE,oBAAA;EAjCN;EAuCI;;IACE,WAAA;EApCN;EAuCQ;;IACE,oBAAA;EApCV;EAuCQ;;;;;;IAGE,iBAAA;IACA,oBAAA;EAlCV;EAyCM;;;;IAEE,oBAAA;IACA,oBAAA;EArCR;EA0CM;;IACE,4DAAA;IACA,WAAA;EAvCR;AACF;AA8CA;EACE;IACE,iBAAA;IACA,UAAA;EA5CF;EA8CE;IACE,gBAAA;IACA,sBAAA;EA5CJ;EA+CE;IACE,aAAA;EA7CJ;AACF;AAoDE;;;;EAIE,gDAAA;EACA,mBAAA;AAlDJ;AAqDE;EACE,gDAAA;EACA,mBAAA;AAnDJ;AAuDE;EACE,oCAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;AArDJ;AAuDI;EACE,wBAAA;EACA,2BAAA;EACA,gCAAA;AArDN;AAwDI;EACE,gCAAA;AAtDN","sourcesContent":["// Main Container\n.sa-company-form-container {\n  min-height: calc(100vh - 118px);\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n  // Form Wrapper - New wrapper structure\n  .sa-company-form-wrapper {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    padding: 1.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    animation: company-form-fade-in 0.3s ease-out;\n    width: 70%;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n      width: 100%;\n    }\n  }\n\n  // Header styling (moved inside wrapper)\n  .sa-company-form-header {\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n    .sa-company-form-title {\n      font-size: 1.6rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 0.5rem 0;\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n      }\n    }\n\n    .sa-company-form-subtitle {\n      font-size: 0.875rem;\n      color: #6b7280;\n      margin: 0;\n    }\n  }\n\n  // Divider styling\n  .sa-company-form-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 1.5rem 0;\n  }\n\n  // Hide old form header (if any remains)\n  .form-header {\n    display: none;\n  }\n\n  // Form styling - Updated to work with wrapper\n  .company-form,\n  .form-content {\n    padding: 0; // Remove padding since it's now in wrapper\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    animation: none;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      padding: 0;\n      width: 100%;\n    }\n\n    // Form sections\n    .form-section {\n      //margin-bottom: 1.5rem;\n      padding-bottom: 1.5rem;\n      // border-bottom: 1px solid #f3f4f6;\n\n      &:last-of-type {\n        border-bottom: none;\n        margin-bottom: 0;\n        padding-bottom: 0;\n      }\n\n      h3 {\n        font-size: 1.125rem;\n        font-weight: 500;\n        color: #374151;\n        margin: 0 0 1rem 0;\n        padding-bottom: 0.5rem;\n        border-bottom: 1px solid #e5e7eb;\n      }\n    }\n\n    // Form grid for company details\n    .form-grid {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 1rem;\n      // margin-bottom: 1.5rem;\n\n      @media (max-width: 768px) {\n        grid-template-columns: 1fr;\n        gap: 0.5rem;\n      }\n\n      .sa-comp-form-group {\n        display: flex;\n        flex-direction: column;\n\n        &.full-width {\n          grid-column: 1 / -1;\n        }\n\n        label {\n          display: block;\n          margin-bottom: 0.5rem;\n          font-weight: 500;\n          font-size: 0.875rem;\n          color: #374151;\n\n          .required {\n            color: #ef4444;\n            margin-left: 0.25rem;\n            font-size: 0.875rem;\n          }\n        }\n\n        // Input styling to match UserForm\n        input,\n        select,\n        textarea {\n          width: 100%;\n          padding: 0.5rem;\n          border: 1px solid #d1d5db;\n          border-radius: 0.25rem;\n          font-size: 0.875rem;\n          font-family: inherit;\n          color: #374151;\n          background: #ffffff;\n          box-sizing: border-box;\n          min-height: 2.5rem;\n\n          &:focus {\n            outline: none;\n            border-color: var(--primary-color, #3b82f6);\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n          }\n\n          &:hover:not(:focus) {\n            border-color: #9ca3af;\n          }\n\n          &::placeholder {\n            color: #9ca3af;\n          }\n\n          &:disabled {\n            background-color: #f9fafb;\n            color: #6b7280;\n            cursor: not-allowed;\n          }\n        }\n\n        select {\n          appearance: none;\n          background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n          background-position: right 0.5rem center;\n          background-repeat: no-repeat;\n          background-size: 1.5rem 1.5rem;\n          padding-right: 2.5rem;\n          cursor: pointer;\n\n          &:disabled {\n            cursor: not-allowed;\n          }\n\n          option {\n            padding: 0.5rem;\n            background: #ffffff;\n            color: #374151;\n          }\n        }\n\n        textarea {\n          resize: vertical;\n          min-height: 4rem;\n          padding: 0.5rem;\n        }\n\n        .error {\n          color: #ef4444;\n          font-size: 0.75rem;\n          margin-top: 0.25rem;\n          font-weight: 500;\n        }\n      }\n\n      .sa-comp-form-group.company-status-toggle {\n        flex-direction: column;\n        gap: 0.75rem;\n        // margin-bottom: 1.5rem;\n\n        label {\n          margin-bottom: 0;\n          cursor: pointer;\n          font-weight: 500;\n          font-size: 0.875rem;\n          color: #374151;\n\n          .required {\n            display: none;\n          }\n        }\n\n        .toggle-switch-simple {\n          position: relative;\n          width: 48px;\n          height: 24px;\n          background-color: #d1d5db;\n          border-radius: 12px;\n          transition: background-color 0.2s ease;\n          cursor: pointer;\n          border: none;\n          padding: 0;\n          min-height: auto;\n\n          &::before {\n            content: '';\n            position: absolute;\n            top: 2px;\n            left: 2px;\n            width: 20px;\n            height: 20px;\n            background-color: white;\n            border-radius: 50%;\n            transition: transform 0.2s ease;\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n          }\n\n          &.active {\n            background-color: var(--primary-color);\n\n            &::before {\n              transform: translateX(24px);\n            }\n          }\n\n          &:focus {\n            outline: 2px solid #3b82f6;\n            outline-offset: 2px;\n          }\n\n          &:disabled {\n            opacity: 0.5;\n            cursor: not-allowed;\n          }\n        }\n\n        .status-text {\n          font-size: 0.75rem;\n          color: #6b7280;\n          margin-left: 0.5rem;\n        }\n      }\n    }\n\n    // Visibility section styling\n    .visibility-section {\n      .module-rights-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 1rem;\n        padding-bottom: 0.75rem;\n        border-bottom: 1px solid #e5e7eb;\n\n        @media (max-width: 768px) {\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 1rem;\n        }\n      }\n\n      h3 {\n        font-size: 1.125rem;\n        font-weight: 500;\n        color: #374151;\n        margin: 0;\n      }\n\n      .override-toggle-container {\n        display: flex;\n        align-items: center;\n\n        .override-toggle-label {\n          display: flex;\n          align-items: center;\n          gap: 0.75rem;\n          font-size: 0.875rem;\n          font-weight: 500;\n          color: #374151;\n          cursor: pointer;\n          margin: 0;\n\n          .override-label-text {\n            user-select: none;\n          }\n        }\n      }\n\n      .custom-rights-info,\n      .plan-rights-info {\n        background-color: #f3f4f6;\n        border-left: 3px solid var(--primary-color, #3b82f6);\n        padding: 0.75rem 1rem;\n        margin-bottom: 1rem;\n        border-radius: 0.375rem;\n\n        p {\n          margin: 0;\n          font-size: 0.875rem;\n          color: #4b5563;\n        }\n      }\n\n      .loading-rights {\n        text-align: center;\n        padding: 2rem;\n        color: #6b7280;\n        font-size: 0.875rem;\n      }\n\n      .visibility-toggles {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n        gap: 1rem;\n        margin-top: 1rem;\n\n        @media (max-width: 768px) {\n          grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n          gap: 0.75rem;\n        }\n      }\n\n      .custom-rights-actions {\n        display: flex;\n        justify-content: flex-end;\n        margin-top: 1.5rem;\n        padding-top: 1rem;\n        border-top: 1px solid #e5e7eb;\n\n        .btn-save-custom-rights {\n          padding: 0.75rem 1.5rem;\n          background-color: var(--primary-color, #3b82f6);\n          color: white;\n          border: none;\n          border-radius: 0.375rem;\n          font-weight: 500;\n          font-size: 0.875rem;\n          cursor: pointer;\n          transition: all 0.2s ease;\n\n          &:hover:not(:disabled) {\n            background-color: #2563eb;\n            transform: translateY(-1px);\n            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n          }\n\n          &:active:not(:disabled) {\n            transform: translateY(0);\n          }\n\n          &:disabled {\n            opacity: 0.6;\n            cursor: not-allowed;\n          }\n\n          @media (max-width: 768px) {\n            width: 100%;\n          }\n        }\n      }\n\n      .toggle-label {\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: #374151;\n        text-transform: capitalize;\n        margin-bottom: 0;\n      }\n\n      .toggle-switch {\n        position: relative;\n        width: 50px;\n        height: 24px;\n        cursor: pointer;\n\n        input {\n          opacity: 0;\n          position: absolute;\n          width: 0;\n          height: 0;\n\n          &:checked+.slider {\n            background-color: var(--primary-color, #3b82f6);\n\n            &::before {\n              transform: translateX(26px);\n            }\n          }\n\n          &:focus+.slider {\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n          }\n        }\n\n        .slider {\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          background-color: #d1d5db;\n          border-radius: 24px;\n          transition: all 0.3s ease;\n\n          &::before {\n            content: '';\n            position: absolute;\n            height: 18px;\n            width: 18px;\n            left: 3px;\n            top: 3px;\n            background-color: white;\n            border-radius: 50%;\n            transition: all 0.3s ease;\n            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n          }\n        }\n\n        &:hover .slider {\n          background-color: #9ca3af;\n\n          input:checked+& {\n            background-color: #2563eb;\n          }\n        }\n      }\n    }\n\n    // Form actions\n    .form-actions {\n      display: flex;\n      justify-content: end;\n      gap: 1rem;\n      padding-top: 1rem;\n      border-top: 1px solid #e5e7eb;\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n      }\n\n      \n      .btn-submit {\n        padding: 0.75rem 1.5rem;\n        border: none;\n        border-radius: 0.375rem;\n        font-weight: 500;\n        font-size: 0.875rem;\n        cursor: pointer;\n        min-width: 120px;\n        transition: all 0.2s ease;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n\n        @media (max-width: 768px) {\n          width: 100%;\n        }\n\n        &:disabled {\n          cursor: not-allowed;\n          opacity: 0.6;\n        }\n      }\n\n      .btn-cancel {\n        // background-color: #dc2626;\n        // color: white;\n\n        // &:hover:not(:disabled) {\n        //   background-color: #b91c1c;\n        // }\n\n        // &:focus {\n        //   outline: none;\n        //   box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\n        // }\n\n        // &:disabled {\n        //   background-color: #d1d5db;\n        //   color: #9ca3af;\n        // }\n        padding: 8px 16px;\n      border: 1px solid #ddd;\n      background: white;\n      color: #666;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 14px;\n\n      &:hover {\n        background-color: #f8f9fa;\n      }\n      }\n\n      .btn-submit {\n        background-color: var(--primary-color);\n        color: white;\n\n        // &:hover:not(:disabled):not(.submitting) {\n        //   background-color: #15803d;\n        // }\n        &:hover{\n          background-color: #005a9a;\n        }\n\n        &:focus {\n          outline: none;\n        }\n\n        &.disabled,\n        &:disabled {\n          background-color: #d1d5db;\n          color: #9ca3af;\n        }\n\n        // &.submitting {\n        //   background-color: #16a34a;\n        //   cursor: not-allowed;\n\n        //   .spinner {\n        //     width: 1rem;\n        //     height: 1rem;\n        //     border: 2px solid transparent;\n        //     border-top: 2px solid white;\n        //     border-radius: 50%;\n        //     animation: spin 1s linear infinite;\n        //   }\n        // }\n      }\n    }\n  }\n\n  // Loading state\n  .loading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 200px;\n    width: 70%;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.375rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n\n  .loading-rights {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem;\n    color: #6b7280;\n    font-size: 0.875rem;\n    font-style: italic;\n  }\n}\n\n// Animations\n@keyframes company-form-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// Responsive design improvements\n@media (max-width: 768px) {\n  .sa-company-form-container {\n    .sa-company-form-wrapper {\n      width: 100%;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .sa-company-form-container {\n    padding: 0.5rem;\n\n    .sa-company-form-wrapper {\n      padding: 0.75rem;\n    }\n\n    .sa-company-form-header {\n      .sa-company-form-title {\n        font-size: 1.125rem;\n      }\n\n      .sa-company-form-subtitle {\n        font-size: 0.8125rem;\n      }\n    }\n\n    .company-form,\n    .form-content {\n      .form-grid {\n        gap: 0.5rem;\n\n        .sa-comp-form-group {\n          label {\n            font-size: 0.8125rem;\n          }\n\n          input,\n          select,\n          textarea {\n            padding: 0.375rem;\n            font-size: 0.8125rem;\n          }\n        }\n      }\n\n      .form-actions {\n\n        .btn-cancel,\n        .btn-submit {\n          padding: 0.5rem 1rem;\n          font-size: 0.8125rem;\n        }\n      }\n\n      .visibility-section {\n        .visibility-toggles {\n          grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n          gap: 0.5rem;\n        }\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .sa-company-form-container {\n    background: white;\n    padding: 0;\n\n    .sa-company-form-wrapper {\n      box-shadow: none;\n      border: 1px solid #000;\n    }\n\n    .form-actions {\n      display: none;\n    }\n  }\n}\n\n// Focus visible improvements for accessibility\n.sa-company-form-container {\n\n  input:focus-visible,\n  select:focus-visible,\n  textarea:focus-visible,\n  button:focus-visible {\n    outline: 2px solid var(--primary-color, #3b82f6);\n    outline-offset: 2px;\n  }\n\n  .toggle-switch input:focus-visible+.slider {\n    outline: 2px solid var(--primary-color, #3b82f6);\n    outline-offset: 2px;\n  }\n\n  // Readonly field styles\n  .readonly-field {\n    background-color: #f5f5f5 !important;\n    cursor: not-allowed !important;\n    opacity: 0.7;\n    color: #6b7280;\n\n    &:focus {\n      outline: none !important;\n      box-shadow: none !important;\n      border-color: #d1d5db !important;\n    }\n\n    &:hover {\n      border-color: #d1d5db !important;\n    }\n  }\n\n//   // Ensure subscription fields have consistent styling\n//   .form-section {\n//     input[name^=\"subscription.\"] {\n//       background-color: #ffffff !important;\n//       color: #374151 !important;\n      \n//       &:autofill,\n//       &:-webkit-autofill,\n//       &:-webkit-autofill:hover,\n//       &:-webkit-autofill:focus,\n//       &:-webkit-autofill:active {\n//         -webkit-box-shadow: 0 0 0 30px #ffffff inset !important;\n//         -webkit-text-fill-color: #374151 !important;\n//         background-color: #ffffff !important;\n//       }\n//     }\n//   }\n// }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
